// extracted by mini-css-extract-plugin
export default {"backButton":"LAfjTz","title":"yx5IHw","list":"NkzC5F","optionButton":"Xpzyza","optionTitle":"NaakDv"};